import S3 from 'aws-s3'
import configJson from './config.json';
var envConfig = (process.env.NODE_ENV == 'development' || process.env.NODE_ENV == 'production') ? process.env.NODE_ENV:'development';
var config = configJson[envConfig];
//console.log(config);
export default {
    GRAPHQL_HTTP: config.url_hasura,
    s3Client(folder = '/') {
        //console.log("envConfigenvConfigenvConfig2222222244444:",envConfig);
        var configS3 = config.configS3;
        configS3.dirName = folder;
        return new S3(configS3)
    },
    fireBase() {
        //console.log("envConfigenvConfigenvConfig222222222:",envConfig);
        return config.firebaseConfig;
    },
    googleMaps() {
        return  config.googleMapsKey;
    },
    calendarOptions() {
        return {
            vi: {
              firstDayOfWeek: 1,
              dayNames: ["Chủ nhật", "Thứ hai", "Thứ 3", "Thứ 4", "Thứ 5", "Thứ 6", "Thứ 7"],
              dayNamesShort: ["CN", "T2", "T3", "T4", "T5", "T6", "T7"],
              dayNamesMin: ["CN", "T2", "T3", "T4", "T5", "T6", "T7"],
              monthNames: ["Tháng 1", "Tháng 2", "Tháng 3", "Tháng 4", "Tháng 5", "Tháng 6", "Tháng 7", "Tháng 8", "Tháng 9", "Tháng 10", "Tháng 11", "Tháng 12"],
              monthNamesShort: ["T1", "T2", "T3", "T4", "T5", "T6", "T7", "T8", "T9", "T10", "T11", "T12"],
              today: 'Hôm nay',
              clear: 'Xóa',
              dateFormat: 'dd/mm/yy',
              weekHeader: 'Tuần'
            }
        }
    }
}